import React from 'react';
type FigureProps = {
  src: string;
  alt: string;
  caption: string;
  label?: string;
  tone?: 'navy' | 'light';
};
export function Figure({
  src,
  alt,
  caption,
  label,
  tone = 'light'
}: FigureProps) {
  const frame = tone === 'navy' ? 'border-white/10 bg-white/[0.03]' : 'border-line bg-white shadow-card';
  const chrome = tone === 'navy' ? 'border-white/10' : 'border-line';
  const labelColor = tone === 'navy' ? 'text-white/55' : 'text-ink-muted';
  const captionColor = tone === 'navy' ? 'text-white/50' : 'text-ink-muted';
  return <figure className="avoid-break" data-id="element-12" data-mp="1ewpfgpjmxoxs">
      <div className={`overflow-hidden rounded-2xl border ${frame}`} data-id="element-13" data-mp="19z78v5t3blsy">
        <div className={`flex items-center gap-2 border-b px-4 py-3 ${chrome}`} data-id="element-14" data-mp="19zh1z29fm92v">
          <span className="h-2 w-2 rounded-full bg-green" aria-hidden="true" data-id="element-15" data-mp="151p6xzdhq6ug" />
          <span className={`h-2 w-2 rounded-full ${tone === 'navy' ? 'bg-white/20' : 'bg-line'}`} aria-hidden="true" data-id="element-16" data-mp="10xhfhufnecsj" />
          <span className={`h-2 w-2 rounded-full ${tone === 'navy' ? 'bg-white/20' : 'bg-line'}`} aria-hidden="true" data-id="element-17" data-mp="w1sfjpzputvp" />
          {label ? <span className={`ml-3 font-sans text-[11px] font-medium uppercase tracking-[0.16em] ${labelColor}`} data-id="element-18" data-mp="36276p44wnntv">
              {label}
            </span> : null}
        </div>
        <img src={src} alt={alt} className="block w-full" data-id="element-19" data-mp="2w906rysxp016" />
      </div>
      <figcaption className={`mt-4 font-sans text-[13px] leading-relaxed ${captionColor}`} data-id="element-20" data-mp="3k1yozh2gfqdo">
        {caption}
      </figcaption>
    </figure>;
}